import Header from './components/Header';
import Hero from './components/Hero';
import TopicSection from './components/TopicSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <Header />
      <main>
        <Hero />
        <TopicSection />
        <RankingSection />
        <FAQSection />
        <CarouselSection />
        <AppSection />
        <ContactSection />
        <IndexSection />
        <AboutSection />
        <UpdatesSection />
        <FeaturesSection />
        <CommentsSection />
        <CardsSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}